import React, { memo, useEffect, useState } from "react"
import Link from "next/link"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import CardLeague from "components/CardLeague"

// eslint-disable-next-line react/display-name
const MySwiper = memo(({ item, leagues }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <div className="relative wapper__swiper__custom">
      {leagues.length > 0 && (
        <Link href={`/leagues`}>
          <div className="w-full flex items-center wapper_see_more justify-between max-lg:mr-4 mr-8 mb-4 max-sm:mb-3">
            <span className="max-sm:text-base max-sm:leading-[22px] text-xl font-semibold text-white">
              {item?.name}
            </span>
            <div
              className={`flex items-center gap-[10px] text-primary text-xs sm:text-sm font-normal whitespace-nowrap`}
            >
              Xem thêm
            </div>
          </div>
        </Link>
      )}
      <Swiper
        key="league_vod"
        spaceBetween={24}
        modules={[Navigation]}
        className="mySwiper"
        navigation={true}
        breakpoints={{
          300: {
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 12
          },
          430: {
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            spaceBetween: 12
          },
          520: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 12
          },
          600: {
            slidesPerView: 1.7,
            slidesPerGroup: 1,
            spaceBetween: 12
          },
          660: {
            slidesPerView: 1.9,
            slidesPerGroup: 1,
            spaceBetween: 12
          },
          730: {
            slidesPerView: 2.2,
            slidesPerGroup: 1
          },
          815: {
            slidesPerView: 2.4,
            slidesPerGroup: 2
          },
          890: {
            slidesPerView: 2.6,
            slidesPerGroup: 2
          },
          965: {
            slidesPerView: 2.8,
            slidesPerGroup: 2
          },
          1055: {
            slidesPerView: 3.1,
            slidesPerGroup: 2
          },
          1170: {
            slidesPerView: 3.3,
            slidesPerGroup: 2
          },
          1200: {
            slidesPerView: 2.7,
            slidesPerGroup: 2
          },
          1255: {
            slidesPerView: 2.9,
            slidesPerGroup: 2
          },
          1310: {
            slidesPerView: 3.1,
            slidesPerGroup: 2
          },
          1400: {
            slidesPerView: 3.3,
            slidesPerGroup: 3
          },
          1460: {
            slidesPerView: 3.5,
            slidesPerGroup: 3
          },
          1536: {
            slidesPerView: 3.7,
            slidesPerGroup: 3
          },
          1600: {
            slidesPerView: 3.9,
            slidesPerGroup: 3
          },
          1685: {
            slidesPerView: 4.2,
            slidesPerGroup: 4
          },
          1775: {
            slidesPerView: 4.4,
            slidesPerGroup: 4
          },
          1850: {
            slidesPerView: 4.6,
            slidesPerGroup: 4
          }
        }}
      >
        {leagues?.length > 0 &&
          leagues?.map((item) => {
            const { id } = item
            return (
              <SwiperSlide key={id}>
                <CardLeague {...item} />
              </SwiperSlide>
            )
          })}
      </Swiper>
    </div>
  )
})

export default MySwiper
